import { Component, OnInit, ElementRef, ViewChild, Input, NgModule } from '@angular/core';
import { TutorService } from 'src/app/service/tutor.service';
import { StorageService } from 'src/app/service/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { ThemePalette } from '@angular/material/core';
import { ModalVideoComponent } from 'src/app/components/jardin/components/dialogs/modal-video/modal-video.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-tutor-card',
  templateUrl: './tutor-card.component.html',
  styleUrls: ['./tutor-card.component.css']
})

export class TutorCardComponent implements OnInit {

  colorSlide: ThemePalette = 'primary';
  disabled = true;
  notifyCont = 0;

  @Input() tutorData : any;
  @Input() indice : number;

  estado = ["Finalizada","Agendada","No Agendada","Realizada"];

  @ViewChild('divSpinner') divSpinner:ElementRef;
  jardines: any;
  idUsuario : any;
  cargando = true;

  constructor(
    private storageService: StorageService,
    private tutorService: TutorService,
    private spinner: NgxSpinnerService,
    private api: apiService,
    public dialog: MatDialog,
    ) 
    { }

  geTutorJardinData(idPersonaPeriodo) {
    this.tutorService.API_POST_getMisUnidadesEducativas(idPersonaPeriodo).subscribe((response:any) => {
      this.jardines = response.payload;
      this.cargando = false;
    },
    (err) => { 
      console.log(err)
    })
  }


  getUrlProfile(idUsuario){
    this.api.API_POST_obtenerFotoPerfil(idUsuario).subscribe((response:any) => {
      const urlPerfil = response.payload;
      if (urlPerfil != null) {
        //this.tutorData["urlPicture"] = urlPerfil;
        this.tutorData["urlPicture"] = "../../../assets/JUNJI_avatar.svg";
      } else {
        this.tutorData["urlPicture"] = "../../../assets/JUNJI_avatar.svg";
      }
      this.cargando = false;
    },
    (err) => { 
      console.log(err)
    })
  }

  ngOnInit() : void {
    this.cargaInicial();
  }

  cargaInicial(){
    this.cargando = true;
    this.spinner.show();
    this.idUsuario = this.storageService.getCurrentUser().idUsuario;
    this.geTutorJardinData(this.tutorData.idPersonaPeriodo);
    this.spinner.hide();
  }

  
  capitalize(string){
    return string[0].toUpperCase() + string.slice(1);
  }

  changeText(element){
    if(element.textContent == '+'){
      element.textContent = '-';
    }else{
      element.textContent = '+';
    }
  }

  calcTime(t1, t2){
    const t1p = Date.parse(t1);
    const t2p = Date.parse(t2);
    
    var mili = t2p - (t1p)
    var min = Math.floor((mili/1000/60) << 0)

    return min;
  }

  isActa(estadoInput){
    let estado = false;
    if(estadoInput == this.estado[0]){
      estado = true
    } 
    return estado;
  }

  showActaTutoria(idJardinPeriodoTutoria) : void{

    var pdfDocumentSrc = environment.apiEndpoint + "tutoria/getActaPDF/" + idJardinPeriodoTutoria;
    const dialogRef = 
    this.dialog.open(ModalVideoComponent, {
      disableClose: true ,
      data: {url: pdfDocumentSrc ,size: 'xl'}
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }


  porcentajeEncuestaTutoria(etData){
    let n = 0;
    let resp = 0;
    if (etData != null) {
      for (let index = 1; index <= 6; index++) {
        if (etData["pregunta"+1] == true) {
          n++
        }
      }
      if (n !=0) {
        resp = ((100*n)/6);
      }
    }
    return resp;
  }
    

}
